//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BackendServices from "@/services/backend-services.js";
import { fileNameFromContent } from "@/utils/name-parser.js";

export default {
  name: "FileUploadInformation",
  components: {},
  props: ["fileInfo"],
  created: function () {
    this.getFileUploadMessages();
  },
  data: function () {
    return {
      newUploadClicked: 0,
      separator: "horizontal",
      pagination: {},
      messageList: {},
      columns: [
        {
          name: "ean",
          align: "left",
          label: "EAN/Código",
          field: (row) => row.code,
        },
        {
          name: "name",
          align: "left",
          label: "Nome",
          field: (row) => row.name,
        },
        {
          name: "nessage",
          align: "left",
          label: "Mensagem",
          field: (row) => row.message,
        },
      ],
      messageTypes: [],
    };
  },
  methods: {
    downloadFile() {

      BackendServices.fileUploadDownloadRequest(this.fileInfo.id).then((response) => {
        const downloadUrl = window.URL.createObjectURL(
          new Blob([response.data])
        );
        const link = document.createElement("a");
        link.href = downloadUrl;
        let fileName = fileNameFromContent(response.headers["content-disposition"]);
        link.setAttribute("download", fileName); //any other extension
        document.body.appendChild(link);
        link.click();
        link.remove();
      });
    },
    async messagesByType(typeId, pagination) {
      let response = null;
      response = await BackendServices.getFileUploadMessages(
        pagination,
        this.fileInfo.id,
        typeId
      );
      this.$set(
        this.pagination[typeId],
        "rowsNumber",
        parseInt(response.headers["x-total-count"])
      );
      return Array.isArray(response.data) ? response.data : [];
    },

    async askForMessagesData(event, typeId) {
      let result = null;
      result = await this.messagesByType(typeId, event.pagination);
      this.$set(this.messageList, typeId, result);
      this.$set(this.pagination, typeId, event.pagination);
    },
    async getFileUploadMessages() {
      BackendServices.getFileUploadMessageTypes().then((response) => {
        this.messageTypes = response.data;

        for (let i = 1; i <= response.data.length; i++) {
          this.messageList[i] = [];
        }
        this.messageTypes.forEach(async (i) => {
          this.$set(this.pagination, i.id, { page: 1, rowsPerPage: 5 });
          let messages = await this.messagesByType(i.id, this.pagination[i.id]);
          this.$set(this.messageList, i.id, messages);
        });
      });
    },

  },
  watch: {
    fileInfo: {
      immediate: true,
      handler: function () {
        this.getFileUploadMessages();
      },
    },
  },
};
